/* eslint-disable*/
import React, { useState, useEffect, useRef } from 'react';
import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { _Q_getAllApplicationsPagedCOMP } from '../query/queries';
const PagedQuery = (props)=>{
    const fetchAll = props.all || false;
    const [paging, setPaging] = useState({page:props.paging.page, pageSize:props.paging.pageSize})
    const [accData, setAccData] = useState([]);
    const lastNotifiedLength = useRef(0);
    
    const [appf_tenant_info] = useState(localStorage.appf_tenant_info?JSON.parse(localStorage.appf_tenant_info):{});
    const deployEnabled = true;
    
    useEffect(()=>{
        setAccData([])
    },[])

    const queryStr = gql`
    query ${props.name}($page: Int, $pageSize: Int) {
     ${"getCurrentApplicationsPaged"==props.name?(deployEnabled?`${_Q_getAllApplicationsPagedCOMP}`:props.query):props.query}
    }`;
 
    const { data: queryData, error: queryError, fetchMore, loading } =  useQuery(queryStr,
        {
            skip:false,
            fetchPolicy: props.fetchPolicy || "no-cache",
            errorPolicy: "all", // Prevents retry on empty responses
            notifyOnNetworkStatusChange: true,
            variables: {
                page: paging.page,
                pageSize: paging.pageSize
              }
        });

        useEffect(() => {
            props.setLoading && props.setLoading(loading);
        }, [loading,props.setLoading]);
        
    useEffect(() => {
        let isMounted = true;

        if (!queryData && !queryError) {
            return; // Don't process until we have data or an error
        }

        try {
            if (queryError) {
                console.error('PagedQuery: GraphQL error', queryError);
                return;
            }

            // Use explicit key names instead of array indices for robustness
            const currentApps = queryData.getCurrentApplications;
            const appComponents = queryData.getApplicationComponents;

            // Validate data structure
            if (!currentApps) {
                console.warn('PagedQuery: getCurrentApplicationsPaged not found in response');
                return;
            }

            const apps = currentApps?.apps;

            // Check if apps is an array
            if (!Array.isArray(apps)) {
                console.warn('PagedQuery: apps is not an array', queryData);
                return;
            }

            let data = [...apps];

            // Add application components if present
            try {
                if (appComponents && Array.isArray(appComponents)) {
                    data = data.concat(appComponents.map(a => ({
                        ...a,
                        applicationTemplateId: "AppComponent",
                        tags: []
                    })));
                }
            } catch (e) {
                console.error('PagedQuery: Error processing application components', e);
            }

            // Validate pageInfo before checking pagination
            const pageInfo = currentApps?.pageInfo;
            if (!pageInfo || typeof pageInfo.currentPage !== 'number' || typeof pageInfo.totalPages !== 'number') {
                console.warn('PagedQuery: Invalid pageInfo structure', pageInfo);
                if (isMounted) {
                    setAccData(prev => {
                        const filtered = [...prev, ...data].filter(a => (props.filter ? a.id == props.filter : true));
                        return filtered;
                    });
                }
                return;
            }

            if (fetchAll && pageInfo.currentPage < pageInfo.totalPages) {
                if (isMounted) {
                    setPaging(p => {
                        let newPage = JSON.parse(JSON.stringify(p));
                        newPage.page += 1;
                        return newPage;
                    });
                    setAccData(p => {
                        let updated = [...p, ...data].filter(a => (props.filter ? a.id == props.filter : true));
                        return updated;
                    });
                }
            } else {
                if (isMounted) {
                    setAccData(p => {
                        let updated = [...p, ...data].filter(a => (props.filter ? a.id == props.filter : true));
                        return updated;
                    });
                }
            }
        } catch (e) {
            console.error('PagedQuery: Error processing query data', e);
        }

        return () => {
            isMounted = false;
        };
    }, [queryData, queryError, fetchAll, props.filter]);

    // Separate effect to notify parent component when accumulated data changes
    useEffect(() => {
        if (accData.length > 0 && accData.length !== lastNotifiedLength.current) {
            lastNotifiedLength.current = accData.length;
            props.setData(accData);
        }
    }, [accData]);
 
     useEffect(() => {
       fetchMore({
         variables: {
             page: paging.page,
             pageSize: paging.pageSize
           },
           updateQuery: (previousResult, { fetchMoreResult }) => {
             return fetchMoreResult;
           }

       })
     }, [paging, fetchMore]); // Removed fetchMore from dependencies - it's stable from useQuery

    return <></>
}

export default PagedQuery